import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
 getSales () {
   return Api().get("/sales");
},
  updateSale (params) {
    return Api().put("/sales",params);
  },
  addSale (params) {
    return Api().post("/sales",params);
  },
  getSale (params) {
    return Api().get("/sales/"+params);
  },
  deleteSale (params) {
    return Api().delete("/sales/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/SaleService.js